import type { Lang } from '../types/funnel';

/** Language is automatic: the first supported browser language wins (es → Spanish, en → English), fallback English. */
export function detectLang(): Lang {
  if (typeof navigator === 'undefined') return 'en';
  const list = [...(navigator.languages ?? []), navigator.language].filter(Boolean);
  for (const l of list) {
    const p = l.toLowerCase().slice(0, 2);
    if (p === 'es') return 'es';
    if (p === 'en') return 'en';
  }
  return 'en';
}
